import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OpportunityListComponent } from './opportunity-list.component';

const routes: Routes = [{ path: '', component: OpportunityListComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OpportunityListRoutingModule {}
